import React from "react";
import { useParams } from "react-router";
import { Upload } from "Components";
import { FILES_ENDPOINT } from "Constants";
import { useAppDispatch, useDialog, useUploadOption } from "Hooks";
import { UploadDialog } from "Modules/upload";
import { uploadFile } from "Services";
import { FileSoftwareInfo, UploadOption } from "Types";
import { apiErrorToast } from "Utils";
import { filesApi } from "../../services/files.api";
import styles from "./upload.module.scss";
import UrlImportWizard from "./UrlImportWizard/UrlImportWizard";

const FileUpload = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const { groupId } = useParams();
  const fileUpload = useDialog();
  const urlImport = useDialog();
  const { uploadOption, handleUploadOptionChange } =
    useUploadOption("FILESTREAM");

  const handleUploadButtonClick = (option: UploadOption) => {
    if (option === "file") {
      fileUpload.open();
    } else {
      urlImport.open();
    }
  };

  const handleSubmit = async (file: File, softwareInfo: FileSoftwareInfo) => {
    if (!file) return;

    const formData = new FormData();

    formData.append("file", file, file.name);
    formData.append("product", softwareInfo.product);
    formData.append("publisher", softwareInfo.publisher);
    formData.append("version", softwareInfo.version);
    formData.append("category", softwareInfo.category);
    formData.append("license", softwareInfo.license);
    formData.append("platform", softwareInfo.platform);
    formData.append("architecture", softwareInfo.architecture);
    formData.append(
      "notify_on_completion",
      `${softwareInfo.notify_on_completion}`,
    );
    formData.append("group_id", groupId || "");
    formData.append("is_released", "false");

    try {
      await uploadFile(`${FILES_ENDPOINT}/upload`, formData, 1);
      dispatch(
        filesApi.util.invalidateTags([{ type: "Files", id: "LIST" }, "Usage"]),
      );
    } catch (error) {
      apiErrorToast(error, "Could not upload the file");
    }
  };

  return (
    <div className={styles["upload-controls-container"]}>
      <Upload.Button
        selectedOption={uploadOption}
        onOptionChange={handleUploadOptionChange}
        onClick={handleUploadButtonClick}
        className={styles["upload-actions"]}
      />
      <UploadDialog
        fileType="FILESTREAM"
        isOpen={fileUpload.isOpen}
        onClose={fileUpload.close}
        onUpload={handleSubmit}
      />
      {urlImport.isOpen && uploadOption !== "file" && (
        <UrlImportWizard isOpen={urlImport.isOpen} onClose={urlImport.close} />
      )}
    </div>
  );
};

export default FileUpload;
